import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';

@Injectable()
export class AuthService {
  isLoggedIn = false;
  savedProjects = '';
 
  // store the URL so we can redirect after logging in
  redirectUrl: string;

  login() {
    return Observable.of(true).do(val => this.isLoggedIn = true);
  }

  logout(): void {
    this.isLoggedIn = false;
    this.savedProjects= localStorage.getItem("savedProject")
    localStorage.clear();
    localStorage.setItem('savedProject', this.savedProjects);
  }
}
